import i18n from 'services/base/i18n';

export default {
  first: () => i18n.pgettext('Components|List History|Filter History|Site Input|Range Input', 'First IP'),
  final: () => i18n.pgettext('Components|List History|Filter History|Site Input|Range Input', 'Final IP'),
};
